/*
 *
 * ----------------------------------------------- */
(function () {
  var $modal = $(".modal-video");

  $modal.each(function (element) {
    var $this = $(this);
    var $video = $this.find("video");

    $this.on("shown.bs.modal", function () {
      $video[0].play();
    });

    $this.on("hidden.bs.modal", function () {
      $video[0].pause();
    });
  });
})();
